import PropTypes from 'prop-types';

import { UI_CONTAINER_TYPE } from 'app/constants/AnalyticsGa4Constants';
import { ROW_CHILD_COMPONENT_TYPE } from 'app/constants/browse/rows';
import { LIST_TYPE } from 'app/constants/list';
import displayBibShape from 'app/shapes/displayBib';

const listShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
  listType: PropTypes.oneOf(Object.values(LIST_TYPE)).isRequired,
  name: PropTypes.string.isRequired,
  owner: PropTypes.number.isRequired
});

export const bibsMappedProps = {
  displayBibs: PropTypes.arrayOf(displayBibShape).isRequired,
  hasHistoryRoutingForTitles: PropTypes.bool,
  title: PropTypes.string.isRequired,
  titleUrl: PropTypes.string.isRequired
};

export const linksMappedProps = {
  links: PropTypes.arrayOf(
    PropTypes.exact({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  ).isRequired,
  title: PropTypes.string.isRequired
};

export const listsMappedProps = {
  lists: PropTypes.arrayOf(listShape).isRequired,
  title: PropTypes.string.isRequired,
  userByListId: PropTypes.objectOf(
    PropTypes.shape({
      active: PropTypes.bool.isRequired,
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      staff: PropTypes.bool.isRequired
    })
  ).isRequired
};

export const listsHeroMappedProps = {
  lists: PropTypes.arrayOf(listShape).isRequired,
  title: PropTypes.string.isRequired,
  userByListId: PropTypes.objectOf(
    PropTypes.shape({
      active: PropTypes.bool.isRequired,
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      staff: PropTypes.bool.isRequired
    })
  ).isRequired
};

export const navMappedProps = {
  links: PropTypes.arrayOf(
    PropTypes.exact({
      isRouterLink: PropTypes.bool,
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  ).isRequired,
  title: PropTypes.string.isRequired
};

export const rowShape = PropTypes.exact({
  childComponent: PropTypes.exact({
    mappedProps: PropTypes.oneOfType([
      PropTypes.shape(bibsMappedProps),
      PropTypes.shape(linksMappedProps),
      PropTypes.shape(listsMappedProps),
      PropTypes.shape(listsHeroMappedProps),
      PropTypes.shape(navMappedProps)
    ]).isRequired,
    type: PropTypes.oneOf(Object.values(ROW_CHILD_COMPONENT_TYPE)).isRequired
  }),
  hasAlternativeStyle: PropTypes.bool.isRequired,
  rowId: PropTypes.string.isRequired,
  uiContainerType: PropTypes.oneOf(Object.values(UI_CONTAINER_TYPE)).isRequired
});
